import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import MenuIconButton from "../../images/gen/icon-menu-blue.svg";
import { useIntl } from "react-intl";
import { useKeycloak } from "@react-keycloak/web";
import { Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import exitIcon from "../../images/gen/icon-exit.svg";
import menuIcon from "../../images/gen/icon-menu.svg";
import homeIcon from "../../images/gen/icon-home.svg";
import searchIcon from "../../images/gen/icon-search.svg";
import patientsIcon from "../../images/gen/icon-user.svg";
import addPatientIcon from "../../images/gen/icon-plus-user.svg";
import {
  GENOME_API_DOWNLOAD_MANUAL,
  PDF_FILE_TITLE,
  ROUTES_HOME,
  ROUTES_PATIENT,
  ROUTES_PATIENTS,
  ROUTES_SEARCH_OMIM,
} from "../../utils/constants";
import { useNavigate } from "react-router";
import {
  storeFamilyBackgroundsActionCreator,
  storePatientDiseasesActionCreator,
  storePatientInitialStateActionCreator,
  storePatientSymptomsActionCreator,
  storeSearchPatientIdActionCreator,
} from "../../reducers/patientState";
import { useDispatch } from "react-redux";
import { storeSearchInitialStateActionCreator } from "../../reducers/searchOmimState";
import iconDoc from "../../images/gen/icon-doc.svg";
import { downloadPdf } from "../../utils/utils";
import { storeUserFoundActionCreator } from "../../reducers/commonState";
const useStyles = makeStyles((theme) => ({
  mainMenu: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  menu: {
    display: "flex",
    flexDirection: "column",
  },
  menuItem: {
    display: "flex",
    justifyContent: "flex-start",
    gap: theme.spacing(2),
    width: "100%",
    color: "white",
    padding: theme.spacing(1, 0),
    paddingLeft: theme.spacing(4),
    "&:hover": {
      cursor: "pointer",
    },
  },
  menuHeader: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: theme.spacing(2),
    width: "100%",
    color: "white !important",
    paddingLeft: theme.spacing(4),
  },
  menuTitle: {
    fontSize: "1.2rem",
  },
  icon: {
    width: 16,
  },
  divider: {
    marginTop: theme.spacing(3),
    height: 1,
    backgroundColor: "white",
  },
}));

const Menu = () => {
  const classes = useStyles();
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { keycloak, initialized } = useKeycloak();

  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen((open) => !open);
  };

  const handleLogOut = () => {
    if (initialized && keycloak.authenticated) {
      keycloak.logout();
    }
  };

  const handleGoToPage = (route) => {
    toggleDrawer();
    navigate(route);
  };

  const handleRedirectToHome = () => {
    localStorage.removeItem("genome-patient-id");
    dispatch(storeSearchPatientIdActionCreator(""));
    handleGoToPage(ROUTES_HOME);
  };

  const handleRedirectToAddPatient = () => {
    localStorage.removeItem("genome-patient-id");
    localStorage.setItem("genome-new-patient", JSON.stringify(true));
    dispatch(storeSearchInitialStateActionCreator());
    dispatch(storePatientInitialStateActionCreator());
    handleGoToPage(ROUTES_PATIENT);
  };

  const handleDownloadPdf = () => {
    downloadPdf(GENOME_API_DOWNLOAD_MANUAL, PDF_FILE_TITLE);
  };

  const handleGoToPatientList = () => {
    localStorage.removeItem("genome-new-patient");
    localStorage.removeItem("genome-patient-id");

    dispatch(storePatientSymptomsActionCreator([]));
    dispatch(storeFamilyBackgroundsActionCreator([]));
    dispatch(storePatientDiseasesActionCreator([]));

    dispatch(storePatientInitialStateActionCreator());
    dispatch(storeSearchInitialStateActionCreator());

    dispatch(storeUserFoundActionCreator());

    handleGoToPage(ROUTES_PATIENTS);
  };

  return (
    <>
      <Button onClick={toggleDrawer}>
        <img src={MenuIconButton} alt={"Menu Icon Button"} />
      </Button>
      <SwipeableDrawer anchor="right" open={open} onClose={toggleDrawer} onOpen={toggleDrawer}>
        <div className={classes.mainMenu}>
          <div className={classes.menu}>
            <div className={classes.menuHeader}>
              <img src={menuIcon} alt={"Icon"} />
              <Typography className={classes.menuTitle}>Main Menu</Typography>
            </div>
            <Divider className={classes.divider} />
            <Button disableRipple onClick={handleRedirectToHome}>
              <div className={classes.menuItem}>
                <img className={classes.icon} src={homeIcon} alt={"Icon"} />
                <Typography>{intl.formatMessage({ id: "home" })}</Typography>
              </div>
            </Button>
            <Button disableRipple onClick={() => handleGoToPage(ROUTES_SEARCH_OMIM)}>
              <div className={classes.menuItem}>
                <img className={classes.icon} src={searchIcon} alt={"Icon"} />
                <Typography>{intl.formatMessage({ id: "searchOmim" })}</Typography>
              </div>
            </Button>
            <Button disableRipple onClick={handleGoToPatientList}>
              <div className={classes.menuItem}>
                <img className={classes.icon} src={patientsIcon} alt={"Icon"} />
                <Typography>{intl.formatMessage({ id: "patients" })}</Typography>
              </div>
            </Button>
            <Button disableRipple onClick={handleRedirectToAddPatient}>
              <div className={classes.menuItem}>
                <img className={classes.icon} src={addPatientIcon} alt={"Icon"} />
                <Typography>{intl.formatMessage({ id: "addPatient" })}</Typography>
              </div>
            </Button>
          </div>
          <div className={classes.menu}>
            <Button disableRipple onClick={handleDownloadPdf}>
              <div className={classes.menuItem}>
                <img className={classes.icon} src={iconDoc} alt={"Icon"} />
                <Typography>{intl.formatMessage({ id: "help" })}</Typography>
              </div>
            </Button>
            <Button disableRipple onClick={handleLogOut}>
              <div className={classes.menuItem}>
                <img className={classes.icon} src={exitIcon} alt={"Icon"} />
                <Typography>{intl.formatMessage({ id: "logout" })}</Typography>
              </div>
            </Button>
          </div>
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default Menu;
